export const ACH_POSITIVE_PAY_NOT_ALLOWED_CODE = 'ach_positive_pay_not_allowed';

export const isNotBusinessAccountError = (error: unknown): boolean =>
  typeof error === 'object' &&
  error !== null &&
  (error as { code?: unknown }).code === ACH_POSITIVE_PAY_NOT_ALLOWED_CODE;

// true = business-eligible (200), false = non-business (400), undefined = loading or any other error.
export const deriveIsBusinessAccount = (query: { isSuccess: boolean; error: unknown }): boolean | undefined => {
  if (query.isSuccess) {
    return true;
  }
  if (isNotBusinessAccountError(query.error)) {
    return false;
  }
  return undefined;
};
